// External libraries
import styled from '@emotion/styled';
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

// Internal modules
import { INPUT_DEFAULT_COLOR, PRIMARY_COLOR_V2 } from '@/styles';
import { getLinkStateStyles } from '@/components/Common';

// CSS styles
export const customInputContainerStyles = css`
  display: flex;
`;

export const inputContainerStyles = css`
  flex-grow: 1;
`;

export const inputStyleOverrides = css`
  border-style: none;
  color: ${INPUT_DEFAULT_COLOR};
  text-overflow: ellipsis;

  &:focus {
    border-style: none;
    box-shadow: none;
  }
`;

// Styled components
export const AddressAndEditContainer = styled.div`
  position: relative;
`;

export const EditButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${PRIMARY_COLOR_V2};
  cursor: pointer;
  font-weight: bold;
  height: auto;
  margin: 5px 15px 5px 0;
  padding: 0;
  ${({ theme }) => getLinkStateStyles(theme)}

  &:focus {
    text-decoration: underline;
  }
`;

export const getCustomInputContainerStyleOverrides = (
  isEditFocused: boolean,
): SerializedStyles => css`
  display: flex;
  align-items: center;

  /* This is a special case.  We don't want to show the focused border in the input itself,
     but in the parent container. */
  ${!isEditFocused &&
  css`
    &:focus-within {
      border-color: ${PRIMARY_COLOR_V2};
      box-shadow:
        0 0 0 0.125rem ${PRIMARY_COLOR_V2} inset,
        0 0 0 0.375rem rgb(16 114 235 / 16%);
    }
  `}
`;
